/* eslint-disable global-require */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { commitMutation, graphql } from 'react-relay';
import { withRouter, Link } from 'found';
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Icon,
  Item,
  Menu
} from 'semantic-ui-react';
import Formsy from 'formsy-react';
import styles from '../Event.scss';
import globalStyles from '../../globals.scss';
import MobileHeader from '../../App/MobileHeader';
import {
  Analytics,
  AvailabilityChecker,
  Dthc,
  GlobalNotifications,
  Intent,
  MobileModal
} from '../../Modules';
import { Loader } from '../../Elements';
import TitleInput from './TitleInput';
import EventDates from './EventDates';
import NewDocument from './NewDocument';
import NewDocumentMenu from './NewDocumentMenu';
import NewWorkspace from './NewWorkspace';
import BookingStatus from './BookingStatus.js';
import nullifyEmptyStrings from '../../../lib/utils/nullifyEmptyStrings';
import DividedComponents from './DividedComponents';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../../lib/stylesheets/SlideTransition.scss';

const ShowEventComponent = class ShowEvent extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func.isRequired,
    sidebarOpen: PropTypes.bool.isRequired,
    event: PropTypes.object,
    node: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    location: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    children: PropTypes.node,
    params: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      error: !this.props.node,
      event: _.cloneDeep(this.props.node),
      documentType: this.props.location.query.type,
      documentTitle: '',
      newDocumentMenuOpen: false,
      newDocumentModalOpen: this.props.location.query.action === 'new',
      newWorkspaceModalOpen: false,
      editWorkspaceOpen: false,
      editWorkspaceTitle: '',
      newWorkspaceTitle: '',
      submitted: false
    };
    this.hasDates = this.hasDates.bind(this);
    this.titleChangeHandler = this.titleChangeHandler.bind(this);
    this.updateTitle = this.updateTitle.bind(this);

    this.handleNewWorkspaceTitleChange = this.handleNewWorkspaceTitleChange.bind(
      this
    );
    this.handleTitleChange = this.handleTitleChange.bind(this);

    this.openNewDocumentMenu = this.openNewDocumentMenu.bind(this);
    this.closeNewDocumentMenu = this.closeNewDocumentMenu.bind(this);
    this.openNewDocumentModal = this.openNewDocumentModal.bind(this);
    this.closeNewDocumentModal = this.closeNewDocumentModal.bind(this);
    this.openNewWorkspaceModal = this.openNewWorkspaceModal.bind(this);
    this.closeNewWorkspaceModal = this.closeNewWorkspaceModal.bind(this);

    this.workspaceDropdownChangeHandler = this.workspaceDropdownChangeHandler.bind(
      this
    );
    this.editWorkspaceTitleChangeHandler = this.editWorkspaceTitleChangeHandler.bind(
      this
    );
    this.createWorkspace = this.createWorkspace.bind(this);
  }

  componentWillMount() {
    if (!this.props.node && this.props.location.query.share_token) {
      this.addWorkspaceToSession();
    }
  }

  componentDidMount() {
    if (this.props.node && this.props.node.user_event) {
      const mutation = graphql`
        mutation ShowEvent_logViewUserEventMutation(
          $input: LogViewUserEventInput!
        ) {
          logViewUserEvent(input: $input) {
            success
          }
        }
      `;

      const environment = this.props.relay.environment;

      commitMutation(environment, {
        mutation,
        variables: { input: { id: this.props.node.user_event.id } }
      });
      // Send decoded event id to Analytics service
      Analytics.trackEvent('viewed-event', {
        event_id: atob(this.props.node.id).match(/(\d+)/)[0]
      });
    }
  }

  addWorkspaceToSession() {
    this.setState({ error: false });
    const onCompleted = () => {
      this.props.relay.refetch(fragmentVariables => fragmentVariables, null);
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation ShowComponent_addWorkspaceToSessionMutation(
        $input: AddWorkspaceToSessionInput!
      ) {
        addWorkspaceToSession(input: $input) {
          workspace {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.location.query;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  transition(e) {
    e.preventDefault();
    this.props.router.push(e.target.getAttribute('to') || '/');
  }

  handleTitleChange(e) {
    this.setState({ documentTitle: e.target.value });
  }

  createWorkspace(successCb) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to create workspace',
        intent: Intent.DANGER
      });
    };
    const onCompleted = response => {
      const newWorkspaceId = response.createWorkspace.workspace.id;
      if (successCb) {
        successCb(newWorkspaceId);
      } else {
        GlobalNotifications.show({
          message: 'Successfully created workspace',
          intent: Intent.SUCCESS
        });
        this.closeNewWorkspaceModal();
      }
      this.props.router.push(`/events/${this.props.node.id}/workspaces`);
      Analytics.trackEvent('created-workspace');
      this.setState({
        newWorkspaceTitle: ''
      });
    };

    const mutation = graphql`
      mutation ShowEvent_CreateWorkspaceMutation(
        $input: CreateWorkspaceInput!
      ) {
        createWorkspace(input: $input) {
          workspace {
            id
          }
          event {
            ...EventShowContainer_node
            ...WorkspacesContainer_node
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          event_id: this.props.node.id,
          title: this.state.newWorkspaceTitle
        }
      },
      onCompleted,
      onError
    });
  }

  updateTitle() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update event title',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated event title',
        intent: Intent.SUCCESS
      });
    };

    // Set default title if null
    const event = nullifyEmptyStrings(this.state.event);
    event.title = event.title ? event.title : '(Untitled Event)';

    if (this.props.node.title !== event.title) {
      const mutation = graphql`
        mutation ShowEvent_UpdateEventMutation($input: UpdateEventInput!) {
          updateEvent(input: $input) {
            event {
              title
            }
          }
        }
      `;

      const { id, title } = this.state.event;
      const optimisticResponse = { updateEvent: { event: { id, title } } };
      const environment = this.props.relay.environment;

      commitMutation(environment, {
        mutation,
        variables: {
          input: {
            id,
            title
          }
        },
        optimisticResponse,
        onCompleted,
        onError
      });
    }
  }

  titleChangeHandler(e) {
    this.setState({
      event: Object.assign(this.state.event, { title: e.target.value })
    });
  }

  editWorkspaceTitleChangeHandler(e) {
    this.setState({ editWorkspaceTitle: e.target.value });
  }

  workspaceDropdownChangeHandler(e, selection) {
    this.props.router.push(selection.value);
  }

  openNewWorkspaceModal() {
    this.setState({ newWorkspaceModalOpen: true });
  }

  closeNewWorkspaceModal() {
    this.setState({ newWorkspaceModalOpen: false });
  }

  openNewDocumentMenu() {
    this.setState({ newDocumentMenuOpen: true });
  }

  closeNewDocumentMenu() {
    this.setState({ newDocumentMenuOpen: false });
  }

  openNewDocumentModal(documentType) {
    this.setState({
      newDocumentModalOpen: true,
      documentType,
      documentTitle: `${this.props.node.title} ${_.startCase(
        _.toLower(documentType)
      )}`
    });
  }

  closeNewDocumentModal() {
    this.setState({
      newDocumentModalOpen: false,
      documentType: null,
      newWorkspaceTitle: ''
    });
  }

  handleNewWorkspaceTitleChange(e) {
    this.setState({ newWorkspaceTitle: e.target.value });
  }

  hasDates(event) {
    const userEventHasDates =
      event.user_event && event.user_event.start_at && event.user_event.end_at;
    const eventHasDates = event.start_at && event.end_at;
    return Boolean(userEventHasDates || eventHasDates);
  }

  render() {
    const {
      children,
      node: event,
      params,
      relay,
      router,
      sidebarOpen,
      toggleSidebar,
      viewer
    } = this.props;
    const location = Object.assign({}, this.props.location, {
      query: {},
      search: ''
    });

    const workspaceDropdownOptions = [
      {
        text: 'Workspaces',
        value: `/events/${params.event_id}/workspaces`
      }
    ];
    if (event && event.user_event) {
      workspaceDropdownOptions.unshift({
        text: 'Summary',
        value: `/events/${params.event_id}`
      });
    }

    const eventDates = (
      <EventDates event={event} relay={relay} viewer={viewer} />
    );

    const bookingStatus = <BookingStatus event={event} relay={relay} />;

    const eventMetaData = [];
    if (event && this.hasDates(event)) eventMetaData.push(eventDates);
    if (event && event.user_event) eventMetaData.push(bookingStatus);

    const newDocumentMenu = (
      <NewDocumentMenu
        button
        text='New'
        className='icon primary'
        icon='plus'
        labeled
        openNewDocumentModal={this.openNewDocumentModal}
        openNewWorkspaceModal={this.openNewWorkspaceModal}
        viewer={viewer}
      />
    );

    return (
      <div>
        {event &&
          <div>
            {viewer &&
              <MobileHeader viewer={viewer} router={router}>
                <div className='menu'>
                  <Item
                    as='a'
                    className={sidebarOpen ? 'active ' : ''}
                    onClick={toggleSidebar}
                  >
                    <Icon name='sidebar' />
                  </Item>
                </div>
                <div className='right menu'>
                  <AvailabilityChecker viewer={viewer} mobile />
                  <Item as='a' onClick={router.push.bind(null, '/search')}>
                    <Icon name='search' />
                  </Item>
                </div>
              </MobileHeader>}
            <div className={styles.headerSection}>
              <Container>
                <Grid stackable>
                  <Grid.Row style={{ paddingBottom: 0 }}>
                    <Grid.Column
                      computer={13}
                      tablet={13}
                      mobile={16}
                      floated='left'
                    >
                      <Formsy.Form className='ui form'>
                        <div className='ui transparent fluid massive'>
                          {event.can_edit &&
                            <Dthc
                              desktop={TitleInput}
                              mobile={TitleInput}
                              title={event.title}
                              onChange={this.titleChangeHandler}
                              commitUpdate={this.updateTitle}
                              handleClickOutside
                            >
                              <div className={styles.title}>
                                {event.title}
                              </div>
                            </Dthc>}
                          {!event.can_edit &&
                            <div className={styles.title}>
                              {event.title}
                            </div>}
                        </div>
                      </Formsy.Form>
                      <div style={{ margin: '1em 0 0 0' }}>
                        <div className={[styles.statusContainer].join(' ')}>
                          <DividedComponents children={eventMetaData} />
                        </div>
                      </div>
                      <div
                        style={{ display: 'table', width: '100%' }}
                        className={globalStyles.mobile}
                      >
                        <div style={{ display: 'table-cell', width: '100%' }}>
                          <Dropdown
                            selection
                            button
                            basic
                            fluid
                            onChange={this.workspaceDropdownChangeHandler}
                            options={workspaceDropdownOptions}
                            value={location.pathname}
                            style={{ marginBottom: '1em' }}
                          />
                        </div>
                        {event.user_event &&
                          <div
                            style={{
                              display: 'table-cell',
                              paddingLeft: '1em'
                            }}
                          >
                            <Button
                              basic
                              icon='plus'
                              onClick={this.openNewDocumentMenu}
                            />
                            <ReactCSSTransitionGroup
                              transitionName='slide'
                              transitionEnterTimeout={300}
                              transitionLeaveTimeout={300}
                            >
                              {this.state.newDocumentMenuOpen &&
                                <MobileModal
                                  open={this.state.newDocumentMenuOpen}
                                  onClose={this.closeNewDocumentMenu}
                                  inline
                                >
                                  <MobileModal.Header>
                                    <div className='menu'>
                                      <Item
                                        as='a'
                                        onClick={this.closeNewDocumentMenu}
                                      >
                                        Cancel
                                      </Item>
                                    </div>
                                  </MobileModal.Header>
                                  <MobileModal.Content>
                                    {newDocumentMenu}
                                  </MobileModal.Content>
                                </MobileModal>}
                            </ReactCSSTransitionGroup>
                          </div>}
                      </div>
                      <Menu
                        pointing
                        secondary
                        className={globalStyles.desktop}
                        style={{
                          borderBottom: 0,
                          marginBottom: 0,
                          marginTop: '2em'
                        }}
                      >
                        {event.user_event && [
                          <Menu.Item
                            as={Link}
                            to={`/events/${params.event_id}`}
                            name='Summary'
                            className={styles.noOutline}
                            active={router.isActive(
                              {
                                location: {
                                  pathname: `/events/${params.event_id}`
                                }
                              },
                              location,
                              { exact: true }
                            )}
                            key='summary'
                          />
                        ]}
                        <Menu.Item
                          as={Link}
                          className={styles.noOutline}
                          name='Workspaces'
                          to={`/events/${event.id}/workspaces`}
                          active={router.isActive(
                            {
                              location: {
                                pathname: `/events/${params.event_id}/workspaces`
                              }
                            },
                            location,
                            { exact: true }
                          )}
                        />
                      </Menu>
                      {event.user_event &&
                        <div>
                          <NewWorkspace
                            closeNewWorkspaceModal={this.closeNewWorkspaceModal}
                            createWorkspace={this.createWorkspace}
                            handleNewWorkspaceTitleChange={
                              this.handleNewWorkspaceTitleChange
                            }
                            newWorkspaceModalOpen={
                              this.state.newWorkspaceModalOpen
                            }
                            newWorkspaceTitle={this.state.newWorkspaceTitle}
                          />
                          <NewDocument
                            location={location}
                            newDocumentModalOpen={
                              this.state.newDocumentModalOpen
                            }
                            newWorkspaceTitle={this.state.newWorkspaceTitle}
                            closeNewDocumentModal={this.closeNewDocumentModal}
                            createWorkspace={this.createWorkspace}
                            documentType={this.state.documentType}
                            handleNewWorkspaceTitleChange={
                              this.handleNewWorkspaceTitleChange
                            }
                            handleTitleChange={this.handleTitleChange}
                            node={event}
                            relay={relay}
                            router={router}
                            title={this.state.documentTitle}
                            viewer={viewer}
                          />
                        </div>}
                    </Grid.Column>
                    <Grid.Column width={3} only={'computer tablet'}>
                      {event.can_edit &&
                        <div style={{ float: 'right' }}>
                          <Popover
                            content={newDocumentMenu}
                            interactionKind={PopoverInteractionKind.CLICK}
                            popoverClassName='pt-popover-content-sizing'
                            position={Position.BOTTOM_RIGHT}
                            inline
                            popoverWillOpen={this.openNewDocumentMenu}
                            popoverWillClose={this.closeNewDocumentMenu}
                          >
                            <Button
                              primary
                              icon
                              labelPosition='left'
                              onClick={this.openNewDocumentMenu}
                            >
                              <Icon name='plus' />
                              New
                            </Button>
                          </Popover>
                        </div>}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </div>
            <Grid container>
              <Grid.Row>
                <Grid.Column width={16}>
                  {children}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>}
        {!event &&
          <div>
            {this.state.error && children}
            {!this.state.error && <Loader />}
          </div>}
      </div>
    );
  }
};

export default withRouter(ShowEventComponent);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/index.js